import React, { useEffect } from 'react';
import { Route, useLocation, withRouter } from 'react-router-dom';
import App from './App';
import { Login } from './pages/Login';
import { Error } from './pages/Error';
import { NotFound } from './pages/NotFound';
import { Access } from './pages/Access';
import { Wizard } from './pages/Wizard';
import { useSelector, useDispatch } from 'react-redux'
import { setUsuarioLogin } from './actions';

const AppWrapper = () => {

    let location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location]);

    switch (location.pathname) {
        /* case '/':
            return <Route path="/" component={Login} />
        case '/error':
            return <Route path="/error" component={Error} />
        case '/notfound':
            return <Route path="/notfound" component={NotFound} />
        case '/access':
            return <Route path="/access" component={Access} />
        case '/wizard':
            return <Route path="/wizard" component={Wizard} />
        case '/App':
            return <Route path="/" component={App} /> */
        default:

            const { usuario } = useSelector(state => ({
                usuario: state.usuario,
            }))

            if (JSON.stringify(usuario) == '{}') {

                let data = JSON.parse(localStorage.getItem('dat'));

                if (data === null) {
                    return <Route path="/" component={Login} />
                } else {

                    const responseUser = { token: '', email: '',idRol:'',idUsuario:'',foto:'',superusuario:false,rolNombre:'' ,permisos:{}, colegios: [], anios: [], general: [],version:'' };

                    responseUser.token = data.token;
                    responseUser.email = data.email;
                    responseUser.idRol = data.idRol;
                    responseUser.idUsuario = data.idUsuario;
                    responseUser.rolNombre = data.rolNombre;
                    responseUser.permisos = data.permisos;
                    responseUser.foto = data.foto;
                    responseUser.superusuario = data.superusuario;

                    responseUser.colegios = data.colegios;
                    responseUser.anios = data.anios;
                    responseUser.general = data.general;
                    responseUser.version = data.version;
                    dispatch(setUsuarioLogin(responseUser));
                    return <App />;
                }

            } else {
                return <App />;
            }

    }
}

export default withRouter(AppWrapper);
